function hostnameFromUrl(value) {
    try {
        const url = new URL(value);
        if (url.protocol !== 'http:' && url.protocol !== 'https:')
            return undefined;
        return url.hostname.toLowerCase().replace(/\.$/, '') || undefined;
    }
    catch {
        return undefined;
    }
}
function domainFromProperty(value) {
    if (!value.startsWith('sc-domain:'))
        return undefined;
    const domain = value.slice('sc-domain:'.length).trim().toLowerCase();
    if (!domain || /[/:]/.test(domain))
        return undefined;
    return domain.replace(/\.$/, '') || undefined;
}
function matchForSite(site, streamHostname) {
    const domain = domainFromProperty(site);
    if (domain) {
        return streamHostname === domain || streamHostname.endsWith(`.${domain}`)
            ? 'domain'
            : undefined;
    }
    return hostnameFromUrl(site) === streamHostname ? 'hostname' : undefined;
}
export function matchGa4WebStreams(site, candidates) {
    return candidates.flatMap((candidate) => {
        const defaultUri = candidate.stream.webStreamData?.defaultUri;
        if (!defaultUri)
            return [];
        const hostname = hostnameFromUrl(defaultUri);
        if (!hostname)
            return [];
        const match = matchForSite(site, hostname);
        if (!match)
            return [];
        return [{ ...candidate, defaultUri, hostname, match }];
    });
}
export function ga4MatchReason(match, site) {
    const stream = match.stream.displayName ?? match.defaultUri;
    const location = match.match === 'domain' ? 'is inside' : 'matches';
    return `Matched Google Analytics web stream ${stream} (${match.defaultUri}): its hostname ${location} ${site}.`;
}
//# sourceMappingURL=matching.js.map